import omit from "lodash/omit";
import React from "react";

export default class SubmitButton extends React.PureComponent {
  render() {
    // Text or label, legacy...
    const { text, label, updateLabel, buttonProps, meta, ...props } = this.props;
    const isUpdate = window.__DATA__ && window.__DATA__.isUpdate;
    const buttonLabel = (isUpdate ? updateLabel : label) || label || text;
    return (
      <div className="af-container" {...omit(props, ["activeTab"])}>
        <button type="submit" className="af-form-button" onClick={this.handleConfirm} {...buttonProps}>
          {buttonLabel || "Submit"}
          {meta && Object.keys(meta).map((key) => <meta key={key} itemProp={key} content={meta[key]} />)}
        </button>
      </div>
    );
  }
}
